import useTspApiResource from "../../hooks/useTspApiResource";
import TspApiService from "../../api/tspApiService";

const NOTHING = () => Promise.resolve({ data: [], meta: { q: "", counts: {} } });

// GET /api/tsp/search?q=...&types=... — a query under 2 characters is not
// sent at all (the server rejects it anyway; this just avoids the round trip).
export default function useTspSearchData(q, types) {
  return useTspApiResource(() => (q && q.trim().length >= 2 ? TspApiService.search({ q: q.trim(), types: types?.length ? types.join(",") : undefined }) : NOTHING()), [q, types?.join(",")]);
}
